export const ENDPOINTS = {
  get: {
    tags: '/api/store-access/tags',
    menus: '/api/store-access/menus',
    products: '/api/store-access/products',
    productsRecommended: '/api/store-access/products/recommended',
    productsHot: '/api/store-access/products/hot',
    productsByMenu: (menuId: string) => `/api/store-access/products/menu/${menuId}`,
    carousel: '/api/store-access/carousels',
    banners: '/api/store-access/banners',
    reviews: '/api/store-access/reviews',
    discount: '/api/store-access/discount',
  },
  post: {
    promocode: '/api/store-access/promocode',
    order: '/api/store-access/order/create',
  },
  auth: {
    login: 'api/auth/login',
    updateUser: 'api/auth/user/update',
    emailVerify: 'api/auth/email/verify',
    createNewUser: 'api/auth/user/create',
    ifUserExists: 'api/auth/user/exists',
    ifEmailExists: 'api/auth/email/exists',
    emailConfirm: 'api/auth/email/confirm',
  },
};
